import type { Company } from '../api/types';
import { t } from '../i18n/messages';
import { useScrolled } from '../hooks/useScrolled';
import { MobileMenu, type NavLink } from './MobileMenu';
import styles from './SiteHeader.module.css';

export function SiteHeader({ company }: { company: Company }) {
  const scrolled = useScrolled();

  const sections: NavLink[] = [
    { href: '#services', label: t.nav.services },
    { href: '#how', label: t.nav.how },
    { href: '#work', label: t.nav.work },
  ];

  const contact: NavLink = { href: '#contact', label: t.nav.contact };

  return (
    <header className={styles.header} data-scrolled={scrolled} id="top">
      <div className={`shell ${styles.inner}`}>
        <a
          className={styles.wordmark}
          href="#top"
          aria-label={`${company.legalName}, ${t.footer.backToTop}`}
        >
          <svg viewBox="0 0 32 32" aria-hidden="true">
            <circle cx="16" cy="16" r="11" fill="none" stroke="var(--accent)" strokeWidth="2.2" />
            <circle cx="16" cy="5" r="3.6" fill="var(--trace)" />
          </svg>
          <b>{company.name}</b>
          <span>OÜ</span>
        </a>

        <nav className={styles.nav} aria-label={t.nav.label}>
          {sections.map((link) => (
            <a key={link.href} className={styles.navLink} href={link.href}>
              {link.label}
            </a>
          ))}

          <a className={styles.navCta} href={contact.href}>
            {contact.label}
          </a>

          {/* Carries Contact too: keeping the pill as well would push the header
              past a 375px viewport. */}
          <MobileMenu links={[...sections, contact]} />
        </nav>
      </div>
    </header>
  );
}
